/* eslint-disable import/prefer-default-export */
import { VISIBILITY_PRIVATE, VISIBILITY_LIMITED } from './domains';

export const ROLE_VISIBILITIES = [VISIBILITY_PRIVATE, VISIBILITY_LIMITED];
